<script setup>
import { computed } from "vue";
import { useStore } from "./functions";

const store = useStore();
const snackbarData = computed(() => store.state.notifications.snackbarData);
const snackbarOpen = computed({
  get: () => snackbarData.value.open,
  set: (val) => {
    store.commit("toggleSnackbar", val);
  },
});
const onCloseSnackbarClicked = () => {
  store.commit("toggleSnackbar", false);
};
</script>

<template>
  <v-snackbar
    v-model="snackbarOpen"
    :color="snackbarData.color"
    :timeout="snackbarData.timeout"
    :top="snackbarData.top"
    min-width="280px"
  >
    <div class="d-flex justify-space-between align-center">
      {{ snackbarData.text }}
      <v-btn icon class="ml-2">
        <v-icon @click="onCloseSnackbarClicked">mdi-close</v-icon>
      </v-btn>
    </div>
  </v-snackbar>
</template>
